
import { LocationsProvider } from "./locationsContext"
import { ClassificationProvider } from "./classificactionContext"
import { UtilesProvider } from "./utilesContext"
import { EquipmentProvider } from "./equipmentContext"
import { RrhhProvider } from "./rrhhContext"
import { InsumoProvider } from "./insumoContext"
import { ClassificationTaskProvider } from "./classificationTaskContext"
import { TypeTaskProvider } from "./typeTaskContext"
import { AssetContextProvider } from "./assetContext"
import { TaskProvider } from "./taskContext"
import { OtProvider } from "./otContext"
import { AuthProvider } from "./authContext"
import { MetricsProvider } from "./metricsContext"
import { AbilityProvider } from "./AbilityContext"
import { ScheduledProvider } from "./scheduledContext"

export const GlobalProvider = ({ children }) => {
    return (
        <UtilesProvider>
            <AuthProvider>
                <AbilityProvider>
                    <ScheduledProvider>
                    <OtProvider>
                        <TaskProvider>
                            <AssetContextProvider>
                                <TypeTaskProvider>
                                    <ClassificationTaskProvider>
                                        <ClassificationProvider>
                                            <LocationsProvider>
                                                <EquipmentProvider>
                                                    <RrhhProvider>
                                                        <InsumoProvider>
                                                            <MetricsProvider>
                                                                {children}
                                                            </MetricsProvider>
                                                        </InsumoProvider>
                                                    </RrhhProvider>
                                                </EquipmentProvider>
                                            </LocationsProvider>
                                        </ClassificationProvider>
                                    </ClassificationTaskProvider>
                                </TypeTaskProvider>
                            </AssetContextProvider>
                        </TaskProvider>
                    </OtProvider>
                    </ScheduledProvider>
                </AbilityProvider>
            </AuthProvider>
        </UtilesProvider>
    )
}



